import { ApplyCTA } from "./ApplyCTA";
import { useT } from "../../i18n";

export const Hero = () => {
  const t = useT();
  return (
    <header id="top" className="sp-hero" data-testid="hero">
      <div className="sp-container">
        <div className="sp-hero-grid">
          <div className="sp-reveal">
            <span className="sp-hero-eyebrow">{t.hero.eyebrow}</span>
            <h1>
              {t.hero.titlePre}
              <em>{t.hero.titleEm}</em>
              {t.hero.titlePost}
            </h1>
            <p className="sp-hero-sub">{t.hero.sub}</p>
            <div className="sp-hero-actions">
              <ApplyCTA testId="hero-cta-primary" variant="primary">
                {t.hero.ctaPrimary}
              </ApplyCTA>
              <a
                href="#approach"
                className="sp-btn sp-btn-ghost"
                data-testid="hero-cta-secondary"
              >
                {t.hero.ctaSecondary}
              </a>
            </div>
          </div>

          <div className="sp-hero-aside sp-reveal">
            <div className="sp-hero-mark" aria-hidden="true">
              <img src="/gaia-portrait.png" alt="Gaia Ferreira" />
            </div>
          </div>
        </div>

        <div className="sp-hero-stats sp-reveal" data-testid="hero-stats">
          {t.hero.stats.map((s) => (
            <div className="sp-stat" key={s.num + s.label}>
              <span className="sp-stat-num">{s.num}</span>
              <span className="sp-stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </header>
  );
};
